import React from 'react'
import cl from './Map.scss'
import cn from 'classnames'
import { loadMaps } from 'Utils/helpers/maps'
import { defaultMapConfig } from 'Utils/data/maps'

const STORE_MAP_DIV_ID = 'grobyMapDiv'

type PropType = {
    onInit: (map: google.maps.Map) => void
    config: google.maps.MapOptions
}

type StateType = {
    loading: boolean
}

export default class Map extends React.Component<PropType, StateType> {
    map: google.maps.Map | null = null
    state = {
        loading: true
    }

    componentDidMount () {
        setImmediate(() =>{
            loadMaps(() => {
                this.map = new google.maps.Map(document.getElementById(STORE_MAP_DIV_ID), { ...defaultMapConfig, ...this.props.config })
                this.props.onInit(this.map)
                this.setState({ loading: false })
            })
        })
    }

    render () {
        return (
            <div id={STORE_MAP_DIV_ID} className={cn(cl.storesMap, { [cl.loading]: this.state.loading })}>
                &nbsp;
            </div>
        )
    }
}
